import { useQuery, useMutation, UseQueryOptions, UseQueryResult } from 'react-query'
import { QueryKeys } from './_query_keys'
import { useState } from 'react'
import { APIEndpoints } from '../constants/api-endpoints'
import { HttpRequest } from '../services/_http'

export const useGetCollections = (searchOptions?: any, options?: UseQueryOptions): UseQueryResult<any> => {
    const method = 'GET'
    const queryKey = [QueryKeys.COLLECTION, searchOptions]
    /** To keeping old data until response received with new data */
    const [keepPreviousData, setkeepPreviousData] = useState(true)
    return useQuery({
        queryKey,
        queryFn: () => HttpRequest({
            url: APIEndpoints.Collection,
            params: searchOptions,
            method
        }),
        refetchOnWindowFocus: false,
        keepPreviousData,
        onError: () => setkeepPreviousData(false),
        onSuccess: () => setkeepPreviousData(true),
        ...options
    })
}

export const useAddCollection= (options?: any) => {
    const method = 'POST'

    return useMutation(({ data }: { data: any }) => HttpRequest({
        url: `${APIEndpoints.Collection}`,
        method,
        data
    }), options)
}

export const useUpdateCollection = (options?: any) => {
    const method = 'PUT'
    return useMutation(({ data, id }: { data: FormData, id: any }) => HttpRequest({
        url: `${APIEndpoints.Collection}/${id}`,
        method,
        headers: {
            'Content-Type': 'multipart/form-data',
        },
        data
    }), options)
}

export const useDeleteCollection = (options?: any) => {
    const method = 'DELETE'
    return useMutation(({ id }: { id: any }) => HttpRequest({
        url: `${APIEndpoints.Collection}/${id}`,
        method,
    }), options)
}

export const useUpdateCollectionStatus = (options?: any) => {
    const method = 'PATCH'
    return useMutation(({ data, id }: { data: any, id: any }) => HttpRequest({
        url: `${APIEndpoints.Collection}/${id}/status`,
        method,
        data
    }), options)
}


export const useCollectionContent = (id: any, options?: UseQueryOptions): UseQueryResult<any> => {

    const method = 'GET'
    const queryKey = [QueryKeys.COLLECTION_CONTENT, id]
    return useQuery({
        queryKey,
        queryFn: () => HttpRequest({
            url: `${APIEndpoints.Collection}/${id}`,
            method
        }),
         enabled: !!id,
         refetchOnWindowFocus: false,
        ...options
    })
}

export const fetchCollectionSearchApi = async (search: string) => {
   const { data } = await HttpRequest({
                url: `${APIEndpoints.Collection}/search/all?search=${encodeURIComponent(search)}`,
                method: 'GET'
            });
            return data.results;
};

export const useCollectionSearch = (searchTerm: string) => {
  return useQuery({
    queryKey: ["collection-search", searchTerm],
    enabled: Boolean(searchTerm.trim()),
    keepPreviousData: true,
    staleTime: 30 * 1000, // 30 seconds
    queryFn: async () => {
      const { data } = await HttpRequest({
        url: `/collections/search/all?search=${encodeURIComponent(searchTerm)}`,
        method: "GET"
      })
      return data
    }
  })
}